import { createSelector } from 'reselect';
import { getLocale } from '../language/selectors';

export const getViewsByDate = (state) =>
  state.platformUsageAnalyticsData.viewsByDate;

export const getViewsBySession = (state) =>
  state.platformUsageAnalyticsData.viewsBySession;

export const getViewsByOSVisits = (state) =>
  state.platformUsageAnalyticsData.viewsByOSVisits;

export const getAllHraStarts = (state) =>
  state.platformUsageAnalyticsData.hraCampaignStatisticsStart;

export const getAllHraCompletions = (state) =>
  state.platformUsageAnalyticsData.hraCampaignStatisticsComplete;

export const getAllSurveyStarts = (state) =>
  state.platformUsageAnalyticsData.surveyStatisticsStart;

export const getAllSurveyCompletions = (state) =>
  state.platformUsageAnalyticsData.surveyStatisticsComplete;

export const getViewsByBrowserVisits = (state) =>
  state.platformUsageAnalyticsData.viewsByBrowserVisits;

export const getViewsByPageEntries = (state) =>
  state.platformUsageAnalyticsData.viewsByPage.pages;

export const getViewsByPageTotal = (state) =>
  state.platformUsageAnalyticsData.viewsByPage.total;

export const getOSVisitsTotal = createSelector([getViewsByOSVisits], (visits) =>
  visits.reduce((total, { hits }) => hits + total, 0)
);

export const getViewsByOSVisitsPercent = createSelector(
  [getViewsByOSVisits, getOSVisitsTotal],
  (osVisits, total) =>
    osVisits.map(({ os, hits }) => ({
      os,
      hits: Math.round((hits / total) * 100)
    }))
);

export const getBrowserVisitsTotal = createSelector(
  [getViewsByBrowserVisits],
  (visits) => visits.reduce((total, { hits }) => hits + total, 0)
);

export const getViewsByBrowserVisitsPercent = createSelector(
  [getViewsByBrowserVisits, getBrowserVisitsTotal],
  (browserVisits, total) =>
    browserVisits.map(({ browser, hits }) => ({
      browser,
      hits: Math.round((hits / total) * 100)
    }))
);

export const totalViewsByDate = createSelector(
  [getViewsByDate],
  (getViewsByDate) =>
    getViewsByDate.reduce((total, { hits }) => hits + total, 0)
);

export const totalSessions = createSelector(
  [getViewsBySession],
  (viewsBySession) =>
    viewsBySession.reduce((total, { hits }) => hits + total, 0)
);

export const getBrowserLegend = createSelector(
  [getViewsByOSVisitsPercent, getLocale],
  (viewsByOSVisits, locale) => {
    return viewsByOSVisits.map(({ os, hits }) => ({
      name: locale === 'fr' ? `${os} - ${hits} %` : `${os} - ${hits}%`
    }));
  }
);

export const getOSLegend = createSelector(
  [getViewsByBrowserVisitsPercent, getLocale],
  (viewsByBrowserVisits, locale) => {
    return viewsByBrowserVisits.map(({ browser, hits }) => ({
      name: locale === 'fr' ? `${browser} - ${hits} %` : `${browser} - ${hits}%`
    }));
  }
);

export const getHraStarts = createSelector(getAllHraStarts, (hraStarts) =>
  hraStarts.reduce((total, { hits }) => hits + total, 0)
);

export const getHraCompletions = createSelector(
  getAllHraCompletions,
  (hraCompletions) =>
    hraCompletions.reduce((total, { hits }) => hits + total, 0)
);

export const getSurveyStarts = createSelector(
  getAllSurveyStarts,
  (surveyStarts) => surveyStarts.reduce((total, { hits }) => hits + total, 0)
);

export const getSurveyCompletions = createSelector(
  getAllSurveyCompletions,
  (surveyCompletions) =>
    surveyCompletions.reduce((total, { hits }) => hits + total, 0)
);

export const getIsLoading = (state) =>
  state.platformUsageAnalyticsData.isLoading;



// WEBPACK FOOTER //
// ./src/actions/platformUsageAnalytics/selectors.js